import { type Theme } from '@mui/material';

import { customPalette } from '@shared/theme/StyleProvider';

export const stickyDialogSx = (theme: Theme) => ({
  '& .MuiBackdrop-root': { backgroundColor: 'rgba(0, 0, 0, 0.3)' },
  '& .MuiDialog-paper': {
    backgroundColor: customPalette.superLightBlue,
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      width: '100%',
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
  '& .MuiDialog-container': {
    [theme.breakpoints.down('sm')]: {
      alignItems: 'end',
    },
  },
});
